import { mockBuilder } from '../../utils/builderHelper.es.js';
import '../../enums/billing/AccountGlobalStatusEnum.es.js';
import '../../enums/billing/AccountingStatusEnum.es.js';
import '../../enums/billing/AssetPurchaseFormatEnum.es.js';
import '../../enums/billing/AssetPurchaseUnavailableCodeEnum.es.js';
import '../../enums/billing/BillingSystemEnum.es.js';
import { CreditKindEnum } from '../../enums/billing/CreditKindEnum.es.js';
import '../../enums/billing/InvoiceStatusEnum.es.js';
import '../../enums/billing/DiscountTypeEnum.es.js';
import '../../enums/billing/PlanFrequencyEnum.es.js';
import '../../enums/billing/ServiceOffersKindEnum.es.js';
import '../../enums/billing/ServiceStatusEnum.es.js';
import '../../enums/billing/SubscriptionStatusEnum.es.js';
import '../../enums/billing/SubscriptionMigrationTypeEnum.es.js';
import '../../enums/billing/SubscriptionMigrationTimingEnum.es.js';
import '../../enums/billing/SubscriptionServiceOfferEnum.es.js';
import '../../enums/billing/BillingCommitmentEnum.es.js';
import { InvoicePreviewCredit, InvoicePreviewProduct, InvoicePreviewMultiProducts } from './InvoicePreviewMultiProducts.es.js';
import { anInvoicePreviewDiscount } from './InvoicePreview.mock.es.js';

function anInvoicePreviewCredit() {
    return mockBuilder(new InvoicePreviewCredit())
        .withAmount(2)
        .withKind(CreditKindEnum.UserBalance)
        .withCurrencyCode('USD')
        .withCurrencySymbol('$');
}
function anInvoicePreviewProduct() {
    return mockBuilder(new InvoicePreviewProduct())
        .withCurrencyCode('USD')
        .withCurrencySymbol('$')
        .withProductCode('fake_product')
        .withQuantity(5)
        .withUnitPrice(5)
        .withUnitPriceUSD(5)
        .withUnitPriceCAD(10)
        .withBaseAmount(25)
        .withBaseAmountUSD(25)
        .withBaseAmountCAD(50)
        .withTotalDiscounts(5)
        .withTotalDiscountsUSD(5)
        .withTotalDiscountsCAD(10)
        .withDiscountPercent(20)
        .withDiscounts([anInvoicePreviewDiscount().withAmount(5)])
        .withSubTotal(20)
        .withSubTotalUSD(20)
        .withSubTotalCAD(40);
}
function aFreeInvoicePreviewProduct() {
    return mockBuilder(new InvoicePreviewProduct())
        .withCurrencyCode('USD')
        .withCurrencySymbol('$')
        .withProductCode('fake_product')
        .withQuantity(1)
        .withUnitPrice(10)
        .withUnitPriceUSD(10)
        .withUnitPriceCAD(20)
        .withBaseAmount(10)
        .withBaseAmountUSD(10)
        .withBaseAmountCAD(20)
        .withTotalDiscounts(10)
        .withTotalDiscountsUSD(10)
        .withTotalDiscountsCAD(20)
        .withDiscountPercent(100)
        .withDiscounts([anInvoicePreviewDiscount().withAmount(10).withValue(100)])
        .withSubTotal(0.0)
        .withSubTotalUSD(0.0)
        .withSubTotalCAD(0.0);
}
function anInvoicePreviewMultiProducts() {
    return mockBuilder(new InvoicePreviewMultiProducts())
        .withProducts([
        anInvoicePreviewProduct().withProductCode('fake_product'),
        aFreeInvoicePreviewProduct().withProductCode('fake_product2'),
    ])
        .withCurrencyCode('USD')
        .withCurrencySymbol('$')
        .withExchangeRateToUsd(1.0)
        .withBaseAmount(25)
        .withBaseAmountUSD(25)
        .withBaseAmountCAD(50)
        .withTotalDiscounts(5)
        .withTotalDiscountsUSD(5)
        .withTotalDiscountsCAD(10)
        .withDiscountPercent(20)
        .withSubTotal(20)
        .withSubTotalUSD(20)
        .withSubTotalCAD(40)
        .withTotalTaxes(4)
        .withTotalTaxesUSD(4)
        .withTotalTaxesCAD(8)
        .withTotalAmount(24)
        .withTotalAmountUSD(24)
        .withTotalAmountCAD(48)
        .withTotalCredits(10)
        .withCredits([anInvoicePreviewCredit().withAmount(10)])
        .withDueAmount(14)
        .withIsTaxComputationSkipped(false);
}
function anInvoicePreviewMultiProductsFree() {
    return mockBuilder(new InvoicePreviewMultiProducts())
        .withProducts([aFreeInvoicePreviewProduct().withProductCode('fake_product')])
        .withCurrencyCode('USD')
        .withCurrencySymbol('$')
        .withExchangeRateToUsd(1.0)
        .withBaseAmount(16)
        .withTotalDiscounts(16)
        .withSubTotal(0)
        .withTotalTaxes(0)
        .withTotalAmount(0)
        .withTotalCredits(0)
        .withCredits(undefined)
        .withDueAmount(0)
        .withIsTaxComputationSkipped(false);
}

export { aFreeInvoicePreviewProduct, anInvoicePreviewCredit, anInvoicePreviewMultiProducts, anInvoicePreviewMultiProductsFree, anInvoicePreviewProduct };
